import { useLocation } from "react-router-dom";
import { AdBanner } from "./AdBanner";

const ADMIN_PATHS = ["/admin"];

export const PageLayout = ({ children }) => {
  const location = useLocation();
  const isAdmin = ADMIN_PATHS.some((p) => location.pathname.startsWith(p));

  if (isAdmin) {
    return <>{children}</>;
  }

  return (
    <div className="relative" data-testid="page-layout-with-ads">
      {/* Left Ad Banner - Desktop only */}
      <div
        className="hidden xl:block fixed left-0 top-1/2 -translate-y-1/2 z-40"
        style={{ width: "160px" }}
        data-testid="ad-sidebar-left"
      >
        <AdBanner slot="left" format="vertical" />
      </div>

      {/* Right Ad Banner - Desktop only */}
      <div
        className="hidden xl:block fixed right-0 top-1/2 -translate-y-1/2 z-40"
        style={{ width: "160px" }}
        data-testid="ad-sidebar-right"
      >
        <AdBanner slot="right" format="vertical" />
      </div>

      {/* Main Content */}
      <div className="xl:mx-[160px]">
        {children}
      </div>
    </div>
  );
};
